import validator from 'validator';

export function cleanEmail(email: string) {
  const cleanedEmail = validator.normalizeEmail(email.replace(/\s+/g, ''), {
    gmail_lowercase: true,
    gmail_convert_googlemaildotcom: true,
    icloud_lowercase: true,
    yahoo_lowercase: true,
    outlookdotcom_lowercase: true,
  });

  return !cleanedEmail ? '' : email;
}

export function isValidEmail(email: string) {
  const cleanedEmail = cleanEmail(email.toLowerCase());
  return (
    cleanedEmail && cleanedEmail.length >= 3 && validator.isEmail(cleanedEmail)
  );
}
